import React, { useLayoutEffect, useState } from 'react';
import styled from 'styled-components';
import { getUnitCirclePoint } from '../util/getUnitCirclePoint';

const Svg = styled.svg`
   .progress-indicator-background,
   .progress-indicator-foreground {
      stroke-width: 15;
      fill: none;
   }

   .progress-indicator-background {
      opacity: 0.25;
      stroke: var(--brand-green);
   }

   .progress-indicator-foreground {
      stroke: currentColor;
   }
`;

const ProgressMeter = ({ progress }) => {
   const [animationTrigger, setAnimationTrigger] = useState(false);
   const point1 = getUnitCirclePoint(315);
   const point2 = getUnitCirclePoint(45);
   const radius = 40;
   const x1 = point1[0] * radius + 50;
   const y1 = point1[1] * radius + 50;
   const x2 = point2[0] * radius + 50;
   const y2 = point2[1] * radius + 50;
   const arcLength = (3 / 4) * 2 * Math.PI * radius;
   const filledDash = progress * arcLength;

   useLayoutEffect(() => {
      setTimeout(() => setAnimationTrigger(true), 1);
   }, []);

   return (
      <Svg viewBox="0 0 100 100" className="progress-indicator">
         <path
            className="progress-indicator-background"
            d={`M${x1} ${y1} A ${radius} ${radius} 0 1 1 ${x2} ${y2}`}
         />
         <path
            className="progress-indicator-foreground"
            d={`M${x1} ${y1} A ${radius} ${radius} 0 1 1 ${x2} ${y2}`}
            style={{
               transition: 'stroke-dasharray 1s ease',
               strokeDasharray: animationTrigger
                  ? `${filledDash} ${arcLength - filledDash}`
                  : `0 ${arcLength}`,
            }}
         />
      </Svg>
   );
};

export { ProgressMeter };
